import { useUsageTracker } from 'marketplace-ui-tracking';
import { useCallback, useRef, useState } from 'react';
import StorefrontFooter from '../components/StorefrontFooter';
import StorefrontUsageTrackerContext from '../context/StorefrontUsageTrackerContext';

// @ts-expect-error untyped module
import StorefrontHeader from '../components/StorefrontHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StorefrontWrapper = ({
  children
}) => {
  const tracker = useUsageTracker();
  const [defaultEventProperties, setDefaultEventProperties] = useState({});
  const mobileFilterButtonRef = useRef(null);
  const focusMobileFilterButton = useCallback(() => {
    if (mobileFilterButtonRef) {
      // @ts-expect-error ref exists check
      mobileFilterButtonRef.current.focus();
    }
  }, [mobileFilterButtonRef]);
  const trackInteraction = useCallback((action, extras = {}) => {
    tracker.track('storefront-interaction', Object.assign({
      action
    }, defaultEventProperties, extras));
  }, [tracker, defaultEventProperties]);
  return /*#__PURE__*/_jsxs(StorefrontUsageTrackerContext.Provider, {
    value: {
      focusMobileFilterButton,
      mobileFilterButtonRef,
      setDefaultEventProperties,
      trackInteraction
    },
    children: [/*#__PURE__*/_jsx(StorefrontHeader, {}), /*#__PURE__*/_jsxs("main", {
      children: [children, /*#__PURE__*/_jsx(StorefrontFooter, {})]
    })]
  });
};
export default StorefrontWrapper;